import React from 'react';
import type { BuilderSection } from 'types/websiteBuilder';
import HeaderSection from './HeaderSection';
import BodySection from './BodySection';
import HeroSection from './HeroSection';
import FeaturesSection from './FeaturesSection';
import TestimonialsSection from './TestimonialsSection';
import FAQSection from './FAQSection';
import CTASection from './CTASection';
import FooterSection from './FooterSection';
import TeamSection from './TeamSection';
import GallerySection from './GallerySection';
import SliderSection from './SliderSection';
import NavigationTilesSection from './NavigationTilesSection';
import CampaignHeroSection from './CampaignHeroSection';

interface SectionRendererProps {
  section: BuilderSection;
  onUpdateData: (data: Record<string, unknown>) => void;
}

const SECTION_COMPONENTS: Record<
  BuilderSection['type'],
  React.ComponentType<{
    data: Record<string, unknown>;
    onUpdateData: (data: Record<string, unknown>) => void;
  }>
> = {
  header: HeaderSection,
  body: BodySection,
  hero: HeroSection,
  features: FeaturesSection,
  testimonials: TestimonialsSection,
  faq: FAQSection,
  cta: CTASection,
  footer: FooterSection,
  team: TeamSection,
  gallery: GallerySection,
  marquee: SliderSection,
  navigationTiles: NavigationTilesSection,
  campaignHero: CampaignHeroSection,
};

function SectionRenderer({ section, onUpdateData }: SectionRendererProps) {
  const Component = SECTION_COMPONENTS[section.type];
  if (!Component) {
    return (
      <div style={{ padding: '1rem', color: 'hsl(0 0% 60%)' }}>
        Unknown section type: {section.type}
      </div>
    );
  }
  return <Component data={section.data} onUpdateData={onUpdateData} />;
}

export default SectionRenderer;
